import { plainToInstance } from "class-transformer";
import CustomerRating from "entities/customerRating";

const SESSION_STORAGE_CUSTOMER_REVIEW_KEY = "customer_review";

export default class CustomerReviewStorageRepository {
  addCustomerRating(customerRating: CustomerRating) {
    if (!customerRating || !customerRating.orderId) {
      return;
    }

    const customerRatingsString = sessionStorage.getItem(SESSION_STORAGE_CUSTOMER_REVIEW_KEY);
    const customerRatings = customerRatingsString ? JSON.parse(customerRatingsString) : [];
    const updatedRatings = customerRatings.filter((rating: CustomerRating) => rating.orderId !== customerRating.orderId);

    updatedRatings.push(customerRating);
    sessionStorage.setItem(SESSION_STORAGE_CUSTOMER_REVIEW_KEY, JSON.stringify(updatedRatings));
  }

  getCustomerRating(orderId: string): CustomerRating | undefined {
    if (!orderId) {
      return undefined;
    }

    const customerRatingsString = sessionStorage.getItem(SESSION_STORAGE_CUSTOMER_REVIEW_KEY);
    if (!customerRatingsString) {
      return undefined;
    }

    const customerRatings = JSON.parse(customerRatingsString) as CustomerRating[];
    const customerRating = customerRatings?.find(rating => rating.orderId === orderId);

    return customerRating ? plainToInstance(CustomerRating, customerRating) : undefined;
  }

  removeCustomerRating(orderId: string) {
    if (!orderId) {
      return;
    }

    const customerRatingsString = sessionStorage.getItem(SESSION_STORAGE_CUSTOMER_REVIEW_KEY);
    if (!customerRatingsString) {
      return;
    }

    const customerRatings = JSON.parse(customerRatingsString) as CustomerRating[];
    const updatedRatings = customerRatings.filter(rating => rating.orderId !== orderId);

    sessionStorage.setItem(SESSION_STORAGE_CUSTOMER_REVIEW_KEY, JSON.stringify(updatedRatings));
  }

  clearCustomerRatings() {
    sessionStorage.removeItem(SESSION_STORAGE_CUSTOMER_REVIEW_KEY);
  }
}
